<template>
    <div class="kpi-cards">
        <!-- Card contenedora para los KPIs -->
        <div class="chart-container">
            <h5>
                <i class="fal fa-chart-bar text-primary"></i> Indicadores Clave
                de Rendimiento
            </h5>

            <!-- Una sola fila con todos los KPIs -->
            <div class="row g-2">
                <KPICard
                    v-for="kpi in todosLosKPIs"
                    :key="kpi.key"
                    :value="kpi.value"
                    :label="kpi.label"
                    :subtitle="kpi.subtitle"
                    :icon="kpi.icon"
                    :card-class="kpi.cardClass"
                    :tooltip="kpi.tooltip"
                />
            </div>
        </div>
    </div>
</template>

<script>
import KPICard from "./KPICard.vue";

export default {
    name: "KPICards",
    components: {
        KPICard,
    },
    props: {
        kpis: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        todosLosKPIs() {
            return [
                // KPIs Principales - Reordenados según prioridad
                {
                    key: "total",
                    value: this.kpis.total || 0,
                    label: "TOTAL SOLICITUDES",
                    subtitle: "En el período",
                    icon: "fal fa-clipboard-list",
                    cardClass: "kpi-card-primary",
                    tooltip:
                        "Total de solicitudes recibidas en el período seleccionado",
                },
                {
                    key: "solicitudes_por_vencer",
                    value: this.kpis.solicitudes_por_vencer || 0,
                    label: "SOLICITUDES POR VENCER",
                    subtitle: "Vencen en los próximos 3 días",
                    icon: "fal fa-exclamation-triangle",
                    cardClass: "kpi-card-danger",
                    tooltip:
                        "Solicitudes pendientes o en proceso cuya fecha de vencimiento real cae entre hoy y los próximos 3 días",
                },
                {
                    key: "resueltas",
                    value: this.kpis.resueltas || 0,
                    label: "RESUELTAS",
                    subtitle: "En el período",
                    icon: "fal fa-check-circle",
                    cardClass: "kpi-card-success",
                    tooltip:
                        "Solicitudes que han sido completadas y resueltas exitosamente en el período",
                },
                {
                    key: "tasa_crecimiento",
                    value: this.formatTasaCrecimiento(
                        this.kpis.tasa_crecimiento
                    ),
                    label: "TASA DE CRECIMIENTO",
                    subtitle: "vs. período anterior",
                    icon: "fal fa-chart-line",
                    cardClass: "kpi-card-purple",
                    tooltip:
                        "Porcentaje de crecimiento de cantidad de solicitudes en el período seleccionado, comparado con el período anterior",
                },
                {
                    key: "tiempo_promedio",
                    value: (this.kpis.tiempo_promedio || 0) + " h",
                    label: "TIEMPO PROMEDIO",
                    subtitle: "Horas de resolución",
                    icon: "fal fa-stopwatch",
                    cardClass: "kpi-card-info",
                    tooltip:
                        "Tiempo promedio de resolución de solicitudes en horas (incluye fines de semana y feriados)",
                },
                {
                    key: "tasa_respuesta",
                    value: (this.kpis.tasa_respuesta || 0) + " %",
                    label: "TASA DE RESPUESTA",
                    subtitle: "Porcentaje",
                    icon: "fal fa-tachometer-alt",
                    cardClass: "kpi-card-warning",
                    tooltip:
                        "Porcentaje de solicitudes resueltas vs solicitudes recibidas",
                },
                /* {
                    key: "sla_cumplidos",
                    value: this.kpis.sla_cumplidos || 0,
                    label: "SLA CUMPLIDOS",
                    subtitle: `${
                        this.kpis.sla_cumplidos_porcentaje || 0
                    }% del total`,
                    icon: "fal fa-check-double",
                    cardClass: "kpi-card-success",
                    tooltip:
                        "Cantidad y porcentaje de solicitudes que cumplieron el SLA",
                },
                {
                    key: "sla_no_cumplidos",
                    value: this.kpis.sla_no_cumplidos || 0,
                    label: "SLA NO CUMPLIDOS",
                    subtitle: `${
                        this.kpis.sla_no_cumplidos_porcentaje || 0
                    }% del total`,
                    icon: "fal fa-times-circle",
                    cardClass: "kpi-card-danger",
                    tooltip:
                        "Cantidad y porcentaje de solicitudes que NO cumplieron el SLA",
                },
                {
                    key: "solicitudes_prorrogadas",
                    value: this.kpis.solicitudes_prorrogadas || 0,
                    label: "SOLICITUDES PRORROGADAS",
                    subtitle: "En el período",
                    icon: "fal fa-clock",
                    cardClass: "kpi-card-dark-purple",
                    tooltip:
                        "Cantidad de solicitudes que han sido prorrogadas en el período seleccionado",
                },
                {
                    key: "solicitudes_vencidas_sin_responder",
                    value: this.kpis.solicitudes_vencidas_sin_responder || 0,
                    label: "VENCIDAS SIN RESPONDER",
                    subtitle: "Requieren atención",
                    icon: "fal fa-exclamation-triangle",
                    cardClass: "kpi-card-danger",
                    tooltip:
                        "Cantidad de solicitudes que han vencido y están pendientes o en proceso, requieren atención inmediata",
                },
                {
                    key: "solicitudes_vencidas_respondidas",
                    value: this.kpis.solicitudes_vencidas_respondidas || 0,
                    label: "VENCIDAS RESPONDIDAS",
                    subtitle: "Ya finalizadas",
                    icon: "fal fa-check-circle",
                    cardClass: "kpi-card-warning",
                    tooltip:
                        "Cantidad de solicitudes que vencieron pero ya fueron resueltas o cerradas",
                },
                {
                    key: "solicitudes_por_vencer_antiguas",
                    value: this.kpis.solicitudes_por_vencer_antiguas || 0,
                    label: "POR VENCER (7 DÍAS)",
                    subtitle: "Sin cerrar +7 días",
                    icon: "fal fa-clock",
                    cardClass: "kpi-card-info",
                    tooltip:
                        "Cantidad de solicitudes no cerradas que han transcurrido 7 días o más desde su creación",
                }, */
            ];
        },
    },
    methods: {
        formatTasaCrecimiento(value) {
            console.log(value, 'value');
            if (value === null || value === undefined) {
                return "0 %";
            }

            // Si el valor es 999.9, significa crecimiento desde cero (período anterior tenía 0 solicitudes)
            if (value >= 999) {
                return "Nuevo";
            }

            // Formatear con signo + si es positivo
            const valor =
                typeof value === "number"
                    ? value.toFixed(1)
                    : parseFloat(value).toFixed(1);
            return (valor >= 0 ? "+" : "") + valor + " %";
        },
    },
};
</script>

<style scoped>
.kpi-cards {
    margin-bottom: 30px;
}

/* Espaciado uniforme entre tarjetas */
.row.g-2 {
    --bs-gutter-x: 0.75rem;
    --bs-gutter-y: 0.75rem;
}

/* Card contenedora estilo MainCharts */
.chart-container {
    background: white;
    border-radius: 14px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    margin-bottom: 20px;
}

.chart-container h5 {
    color: #495057;
    margin-bottom: 20px;
    font-weight: 600;
}

/* Responsive para móviles */
@media (max-width: 768px) {
    .chart-container {
        padding: 15px;
    }

    .chart-container h5 {
        font-size: 1.1rem;
    }
}
</style>
